import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  productClick,
  addToCartEvent,
  pushRemarketingEvent,
} from '../lib/gaEnhancedEcommerce';
import { css } from '@emotion/core';
import moment from 'moment';

import A from '../Anchor/Anchor';
import Price from '../Price/Price';
import Cart from '../Icons/Cart';

import {
  addToCart,
  isInCart,
  quantityInCart,
  getMaxAddable,
} from '../../../redux/modules/cart';

import Timer from '../Timer/Timer';
import { ga4AddToCart, ga4SelectItem } from '../lib/ga4EnhancedEcommerce';
import { fkmxAddToCart, fkmxSelectItem } from '../lib/farmakomMetrics';
import { FaInfoCircle } from 'react-icons/fa';
import CartQuantity from '../CartQuantity/CartQuantity';

import './ProductThumbnail.scss';
import { ImageDispatcher } from '../ImageDispatcher/ImageDispatcher';

class ProductThumbnail extends Component {
  addToCart = (event, quantity) => {
    event.preventDefault();
    const product = this.props.product;
    this.props.addToCart(product, quantity);

    if (this.props.advancedGa) {
      addToCartEvent({
        id: product.code || '',
        name: product.name,
        category: product.categoryName,
        brand: product.brand,
        price: product.price,
        quantity: quantity,
      });
    }

    // GA4 ADD TO CART
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4AddToCart(product, this.props.ga4ListInfo);
    }

    // FKMX ADD TO CART
    if (this.props.hasFarmakomMetrics) {
      fkmxAddToCart(product, this.props.ga4ListInfo);
    }
  };

  getPath = () => {
    const product = this.props.product;
    return `/${product.type}/${product.categorySeoName}/${
      product.subcategorySeoName ? product.subcategorySeoName : '_'
    }/${encodeURIComponent(product.seoName)}`;
  };

  goToProduct = event => {
    event.preventDefault();
    const product = this.props.product;

    const productGA = {
      id: product.code,
      name: product.name,
      category: product.categoryName,
      brand: product.brand,
    };

    if (this.props.advancedGa) {
      // GOOGLE ANALYTICS: PRODUCT CLICK
      // THEN ROUTER PUSH
      productClick(productGA, this.props.list);
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('product', product);
    }

    // GA4 SELECT ITEM
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4SelectItem(product, this.props.ga4ListInfo);
    }

    // FKMX SELECT ITEM
    if (this.props.hasFarmakomMetrics) {
      fkmxSelectItem(product, this.props.ga4ListInfo);
    }

    this.props.router.push(this.getPath());
  };

  renderAvailabilityClass() {
    let { product, sellProductsOutOfStock } = this.props;

    if (sellProductsOutOfStock && !product.maxNumInCart) {
      return 'available';
    }

    const minAvailable = product.maxNumInCart
      ? Math.min(product.stock, product.maxNumInCart)
      : product.stock;

    if (minAvailable === 0) {
      return 'not-available';
    } else if (minAvailable > 0 && minAvailable < 10) {
      return 'availability-warning';
    } else {
      return '';
    }
  }

  renderAvailability() {
    let { product, sellProductsOutOfStock } = this.props;

    function capitalizeFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }

    // è presente una data di disponibilità
    if (!!product.availabilityDate) {
      // la data è nel futuro
      if (new Date(product.availabilityDate) > new Date()) {
        return (
          'Spedizione dal ' +
          moment(new Date(product.availabilityDate)).format('DD-MM-YYYY')
        );
      }
    }

    // VENDE FUORI STOCK
    if (sellProductsOutOfStock || !!product.sellProductsOutOfStock) {
      if (product.stock === 0) {
        return 'Disponibile in 24 ore';
      }
      if (product.maxNumInCart) {
        return `Max ${product.maxNumInCart} pezzi acquistabili`;
      }
      return 'Disponibile';
    }

    // NON VENDE FUORI STOCK
    if (product.stock === 0) {
      return (
        <div className="discount reorder">
          {capitalizeFirst('Prodotto esaurito')}
        </div>
      );
    } else if (product.stock === 1) {
      // return 'Ultimo pezzo disponibile';
      return (
        <div className="discount advice">
          {/* {capitalizeFirst('Scelto dal farmacista')} */}
          {capitalizeFirst('Ultimo pezzo')}
        </div>
      );
    } else if (product.stock < 10) {
      if (product.maxNumInCart && product.maxNumInCart < product.stock) {
        return `Max ${product.maxNumInCart} pezzi acquistabili`;
      }
      return `Ultimi ${product.stock} pezzi disponibili`;
    }

    // NON VENDE FUORI STOCK E STOCK >= 10
    if (product.maxNumInCart) {
      return `Max ${product.maxNumInCart} pezzi acquistabili`;
    }

    // NON VENDE FUORI STOCK, STOCK >= 10 E NESSUN LIMITE SUI PEZZI ORDINABILI
    return null;
  }

  renderDiscount = (discount, price, listPrice, secondaryColor, uiVariant) => {
    const discountStyle = css`
      & {
        font-size: 12px;
      }
    `;

    //   &.variant-1 {
    //     top: -15px;
    //     right: -15px;
    //     width: 60px;
    //     height: 60px;
    //     padding: 15px 0;
    //     font-size: 18px;
    //     border-radius: 50%;
    //     letter-spacing: 1px;

    //     span {
    //       font-size: 19px;
    //     }
    //   }
    //   &.variant-2 {
    //     top: -1px;
    //     right: -1px;
    //     padding: 0 6px 3px;
    //     font-size: 14px;
    //     border-bottom-left-radius: 6px;
    //     letter-spacing: 0.5px;

    //     span {
    //       font-size: 15px;
    //     }
    //   }
    //   &.variant-3 {
    //     top: 10px;
    //     right: 20px;
    //     padding: 0 8px 1px;
    //     font-size: 14px;
    //     border-radius: 15px;
    //     letter-spacing: 0.5px;

    //     span {
    //       font-size: 15px;
    //     }
    //   }
    //   &.variant-4 {
    //     top: -1px;
    //     right: -1px;
    //     padding: 0 6px 3px;
    //     font-size: 14px;
    //     border-bottom-left-radius: 6px;
    //     letter-spacing: 0.5px;

    //     span {
    //       font-size: 15px;
    //     }
    //   }
    // `;

    if (discount) {
      return (
        // <div className={`discount variant-${uiVariant}`} css={discountStyle}>
        <div className={`discount`} css={discountStyle}>
          {discount.toFixed(0)}
          <span style={{ fontWeight: '400' }}>% di sconto</span>
        </div>
      );
    } else if (listPrice - price > 0) {
      const discountPercent = ((100 * (listPrice - price)) / listPrice)
        .toFixed(0)
        .replace('.', ',');

      return (
        // <div className={`discount variant-${uiVariant}`} css={discountStyle}>
        <div className={`discount`} css={discountStyle}>
          {discountPercent}
          <span>% di sconto</span>
        </div>
      );
    }

    return null;
  };

  renderAddToCart = (isSmall = false, quantity = 1) => {
    return (
      <A
        href="#"
        className={`add-to-cart ${isSmall ? 'small' : ''} ${
          this.props.maxAddable > 0 ? '' : 'disabled'
        }`}
        style={{
          borderRadius: 4,
          padding: 4,
          maxHeight: 40,
          marginTop: 8,
        }}
        onClick={event => {
          event.stopPropagation();
          event.preventDefault();
          if (this.props.maxAddable > 0) {
            this.addToCart(event, quantity);
          }
        }}
      >
        {' '}
        {this.props.maxAddable > 0 ? (
          <span style={{ padding: '1rem' }}>
            {!this.props.isMobile
              ? this.props.isInCart
                ? 'Aggiungi un altro'
                : 'Aggiungi'
              : null}
            {!!this.props.isMobile && 'Aggiungi'}
            <Cart />
          </span>
        ) : (
          <span>In riordino</span>
        )}
      </A>
    );
  };

  addZero = int => {
    return int <= 9 ? `0${int}` : `${int}`;
  };

  renderShippingDay = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    if (this.props.store.features.hasBrtFastShipping) {
      tomorrow.setDate(tomorrow.getDate() + 1);
    } else {
      tomorrow.setDate(tomorrow.getDate() + 2);
    }
    const now = new Date().setUTCHours(
      new Date().getUTCHours() - new Date().getTimezoneOffset() / 60
    );
    const hour = new Date(now).getUTCHours();
    const day = new Date(now).getDay();
    if (this.props.store.features.hasBrtFastShipping) {
      if (day === 5) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Lunedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else if (day === 6 || day === 0) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Mercoledì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else {
        if (hour < 18) {
          return (
            <span>
              Ricevilo <b className={'shipping-day'}>Domani</b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo <b className={'shipping-day'}>Dopodomani</b>
            </span>
          );
        }
      }
    } else {
      //non ha la spedizione bartolini in un giorno
      //ordine di venerdì
      if (day === 5 || day === 4) {
        if (hour < 18) {
          return (
            //arrivo lunedì
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Lunedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            //arrivo martedì
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else if (day === 6) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Mercoledì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else if (day === 0) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Mercoledì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Giovedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else {
        if (hour < 18) {
          return (
            <span>
              Ricevilo <b className={'shipping-day'}>Dopodomani</b>
            </span>
          );
        } else if (day === 1) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Giovedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else if (day === 2) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Venerdì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else if (day === 3) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Lunedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      }
    }
  };

  renderFastShippingCountdown = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const now = new Date().setUTCHours(
      new Date().getUTCHours() - new Date().getTimezoneOffset() / 60
    );
    const hour = new Date(now).getUTCHours();
    const day = new Date(now).getDay();

    if (hour < 18) {
      let today = new Date();
      today.setHours(18);
      today.setMinutes(0);
      today.setSeconds(0);

      return <Timer dateEnd={today} home />;
    } else {
      let today = new Date();
      let tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(18);
      tomorrow.setMinutes(0);
      tomorrow.setSeconds(0);
      return <Timer dateEnd={tomorrow} home />;
    }
  };

  renderShippingTime = () => {
    return (
      <div style={{ marginTop: 12 }}>
        <div className={'shipping-time'}>
          {this.renderShippingDay()}
          <br />
          Se ordini entro: {this.renderFastShippingCountdown()}
        </div>
      </div>
    );
  };

  renderThumbnail = thumbnailStyle => {
    const {
      product,
      siteName,
      primaryColor,
      secondaryColor,
      isCountdown = false,
      coloredBackgroundProducts,
      productsThumbnail,
      hasQuantity,
      onIncrement,
      onDecrement,
      quantity,
      disableGoToProduct,
      productToCart,
      hasCart,
      uiVariantButton,
      lazy,
    } = this.props;

    return (
      <div
        className={`product version-${productsThumbnail} ${
          isCountdown ? 'countdown' : ''
        } ${
          product.discount ? 'special-offer' : ''
        } ${this.renderAvailabilityClass()}`}
        css={thumbnailStyle}
      >
        <div
          className="visible-content"
          style={{
            maxHeight:
              productsThumbnail === 2 || productsThumbnail === 3
                ? 460
                : coloredBackgroundProducts
                ? 380
                : 'auto',
          }}
        >
          <A
            href={disableGoToProduct ? null : this.getPath()}
            onClick={disableGoToProduct ? null : this.goToProduct}
            style={{ color: '#4f4f4f' }}
          >
            <div className="product-content">
              <div className="product-image">
                <ImageDispatcher
                  src={product.image}
                  alt={product.imageAltText || `${product.name} - ${siteName}`}
                  style={{
                    objectFit: 'contain',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 240,
                  }}
                  className={lazy && 'lazyload'}
                />
              </div>

              <div className="text-container">
                <div className="description">{product.name.toLowerCase()}</div>
                {this.renderDiscount(
                  product.discount,
                  product.price,
                  product.listPrice,
                  primaryColor,
                  secondaryColor,

                  productsThumbnail
                )}
                <div className="price-availability">
                  <div className={`price-container`}>
                    {productsThumbnail !== 1 &&
                      !!product.listPrice &&
                      product.listPrice > product.price && (
                        <div className="prev-price">
                          <Price
                            productsThumbnail={productsThumbnail}
                            amount={product.listPrice}
                          />
                        </div>
                      )}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: disableGoToProduct
                          ? 'space-between'
                          : null,
                        marginBottom: disableGoToProduct ? '10px' : '0px',
                      }}
                    >
                      <div className="price">
                        <Price
                          productsThumbnail={productsThumbnail}
                          amount={product.price}
                        />
                      </div>
                      {productsThumbnail === 1 &&
                        !!product.listPrice &&
                        product.listPrice > product.price && (
                          <div className="prev-price">
                            {productsThumbnail === 1 && (
                              <span
                                className="desktop"
                                style={{
                                  marginLeft: '3px',
                                  marginRight: '3px',
                                  textDecoration: 'none',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                invece di:
                              </span>
                            )}
                            <Price
                              productsThumbnail={productsThumbnail}
                              amount={product.listPrice}
                            />
                          </div>
                        )}

                      {!!hasQuantity && (
                        <div>
                          <CartQuantity
                            productName={product.name}
                            className="cart-quantity"
                            value={quantity}
                            onIncrement={onIncrement}
                            onDecrement={onDecrement}
                            primaryColor={primaryColor}
                            uiVariantButton={uiVariantButton}
                          />
                          {product.minNumInCart && (
                            <span className="min-in-cart">
                              Quantità min. {product.minNumInCart}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                    {!!product.lowestPriceLast30Days && (
                      <div class="tooltip-lowest-price">
                        <s
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 4,
                          }}
                        >
                          <Price amount={product.lowestPriceLast30Days} />
                          <FaInfoCircle
                            size={14}
                            onClick={e => e.stopPropagation()}
                          />
                        </s>
                        <span class="tooltiptext">
                          Prezzo più basso praticato nei 30 giorni
                        </span>
                      </div>
                    )}
                  </div>
                  {productsThumbnail === 1 && (
                    <div
                      className="availability"
                      style={{
                        color: '#7A7A7A',
                        fontSize: 14,
                        minHeight: '16px',
                        marginBottom: '4px',

                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '18px',
                      }}
                    >
                      {this.renderAvailability()}
                    </div>
                  )}
                </div>

                {(!!productToCart || !!hasCart.addToCart) && (
                  <div>{this.renderAddToCart(false, quantity)}</div>
                )}
              </div>
            </div>
          </A>
        </div>
      </div>
    );
  };

  render() {
    const { primaryColor, secondaryColor, productToCart, hasCart } = this.props;
    let cartHeight = '168px';

    if (!!productToCart) {
      cartHeight = 'auto';
    } else if (!!hasCart.addToCart) {
      cartHeight = '216px';
    }

    const thumbnailStyle = css`
      &.version-1 {
        .visible-content {
          & a > .product-content > .text-container {
            padding: 16px;
            justify-content: flex-start;

            & .description {
              text-transform: capitalize;
              min-height: unset;
              margin-bottom: 4px;
            }

            & .discount {
              position: initial;
              display: flex;
              align-items: center;
              background-color: ${secondaryColor};
              color: #ffff;
              padding: 4px 8px;
              border-radius: 6px;
              width: 120px;
              font-size: 14px;
              font-weight: 700;
            }
            & .discount.reorder {
              background-color: #ed5a5a;
              position: absolute;
              right: -4%;

              font-size: 14px;
              width: 140px;
            }
            & .discount.advice {
              background-color: #222222;
              position: absolute;
              right: -4%;

              font-size: 14px;
              width: 172px;
            }
          }
          & a > .product-content > .product-image {
            height: 200px;
            img {
              padding-top: 25px;
              padding-bottom: 5px;
            }
          }
        }
      }

      &.version-2 {
        .visible-content {
          background-color: #f8f8f8;
          border: 1px solid #d0d1d4;

          justify-content: flex-start;

          & a > .product-content > .product-image {
            background-color: #fff;
          }

          & a > .product-content > .text-container {
            padding: 16px;
            background-color: #f8f8f8;
            height: ${cartHeight};
            & .description {
              text-transform: uppercase;
              // -webkit-line-clamp: 3;
            }
          }

          .discount {
            width: 100px;
            height: 28px;
            background-color: ${primaryColor};
            color: #ffff;
          }
        }
      }
      // usiamo solo versione 2 con background color bianco (se grigio come da originale
      // versione del design n.3 non risulta compatibile con le foto dei prodotti)
    `;

    return <div>{this.renderThumbnail(thumbnailStyle)}</div>;
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isMobile: state.layout.isMobile,
    isInCart: isInCart(state, ownProps.product.id),
    quantityInCart: quantityInCart(state, ownProps.product.id),
    maxAddable: getMaxAddable(state, ownProps.product),
    siteName: state.store.data.datiFarmacia.siteName,
    sellProductsOutOfStock:
      state.store.data.funzionalita.sellProductsOutOfStock,
    advancedGa: state.store.data.features.advancedGa,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    productsThumbnail: state.store.data.home.visualVariants.thumbnailProduct,
    store: state.store.data,
    products: state.products.data,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    hasCart: state.store.data.loghiTemplate.productThumbnail,
  };
}

ProductThumbnail = withRouter(ProductThumbnail);

export default connect(mapStateToProps, { addToCart })(ProductThumbnail);
